/* eslint no-useless-escape: 0 */
export const validatePhone = (val) => {
	let valid = false
	const phone = val || '';
	let errorMsg = ''
	const REGEX_PHONE_NUMBER = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/

	if (phone && !REGEX_PHONE_NUMBER.test(phone)) {
		errorMsg = 'Số điện thoại không hợp lệ'
	} else if (phone?.length === 0) {
		errorMsg = 'Vui lòng nhập số điện thoại'
	} else if (phone?.length > 10 || phone?.length < 10) {
		errorMsg = 'Số điện thoại có 10 chữ số'
	} else {
		valid = true
	}

	return { valid, errorMsg }
}

export const allowScroll = (isScroll) => {
	if (typeof window === 'undefined') return
	const html = document.getElementsByTagName("html")?.[0]
	if (html && html?.style) {
		if (!isScroll) html.style.overflow = 'hidden'
		else html.style.overflow = 'auto'
	}
}

export const formatNumberDisplay = (value) => {
	return Math.floor(Number(value) / 10) <= 0 ? `0${value}` : value
}
export const getFullDateString = (dateTime) => {
	if (!dateTime) {
		dateTime = new Date()
	}
	const date = new Date(dateTime)
	const getHours = formatNumberDisplay(date.getHours())
	const getMinute = formatNumberDisplay(date.getMinutes())
	const getDay = date.getDay()
	const day = String(date.getDate()).padStart(2, '0');
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const year = date.getFullYear();
	const enumDay = {
		0: 'Chủ nhật',
		1: 'Thứ 2',
		2: 'Thứ 3',
		3: 'Thứ 4',
		4: 'Thứ 5',
		5: 'Thứ 6',
		6: 'Thứ 7',

	}
	return `${getHours}:${getMinute} ${enumDay[getDay]} ngày ${day}/${month}/${year}`
}